export enum DateAlignment {
    IgnoreNonMatching,
    AlignOnPrevious
}